import { MessageService } from '@philips-internal/oswald-ui-core/lib/services/index.js';
import { isMobileResolution } from '@philips-internal/oswald-ui-utils';
import { format } from '../formatters/date/date.js';
function getPrettyDateValue(value, defaultPrettyValue) {
    if (!value || value.length <= 0) {
        return defaultPrettyValue;
    }
    const options = { type: 'date' };
    if (Array.isArray(value)) {
        const [startDate, endDate] = value;
        const startDateFormatted = format(startDate, options);
        const endDateFormatted = format(endDate, options);
        return `${startDateFormatted}${endDate ? ` - ${endDateFormatted}` : ''}`;
    }
    return format(value, options);
}
function getPrettyListValue(value, defaultPrettyValue) {
    if (!value || value.length <= 0) {
        return defaultPrettyValue;
    }
    if (isMobileResolution() || value.length === 1) {
        const [{ label }] = value;
        return value.length > 1 ? `${MessageService.translate(label)}, ...` : MessageService.translate(label);
    }
    const labels = value
        .map(item => MessageService.translate(item.label))
        .join(', ');
    return labels;
}
function getPrettyTimeValue(value) {
    if (Array.isArray(value)) {
        const [from = '', until = ''] = value;
        return MessageService.translate('tws.time-field.interval-time-pretty-value', { from, until });
    }
    return MessageService.translate('tws.time-field.time-pretty-value', { value });
}
export { getPrettyDateValue, getPrettyListValue, getPrettyTimeValue, };
//# sourceMappingURL=get-pretty-value.js.map